import GiftingSection from '../components/GiftingSection.js';
import Banner from '../components/Banner.js';
import Form from '../components/Form.js';

const Gifting = () => {
    return (
        <>
            <div style={{ background: "linear-gradient(to right, #fff8f0, #f5f5f5)" }}>
                <Banner
                    image="https://static.vecteezy.com/system/resources/thumbnails/032/835/006/small_2x/christmas-greeting-card-or-christmas-banner-design-gift-box-and-ornaments-on-light-green-background-with-magic-lights-photo.jpg"
                    heading="Gifting"
                />
                <GiftingSection />


                <div className='d-md-flex d-block'>
                    <div className='w-100 w-md-50'> <Form /></div>

                    <div className='w-100 w-md-50 h-full d-flex'>
                        <div className="d-flex flex-column align-items-center justify-content-around rounded-4 p-4 h-full">
                            <div className="col-md-12 text-center text-md-start mb-4 mb-md-0">
                                <h2 className="fw-bold display-5 fs-3">Perfect Gifts for Every Occasion</h2>
                                <p className="lead mt-3">
                                    Surprise your loved ones with our curated collection of thoughtful and elegant gifts.
                                    From personalized items to premium hampers, we’ve got something special for everyone.
                                </p>
                                <p className="lead mt-3">
                                    Surprise your friends and family with gifts that speak from the heart. Unique,
                                    personalized, and beautifully packaged — perfect for every celebration.
                                </p>
                                <p className="lead mt-3">
                                    Elevate your gifting game with elegant hampers and exclusive collections.
                                    Perfect for Diwali, birthdays, anniversaries, or corporate events.
                                </p>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}

export default Gifting;